export default "__VITE_ASSET__d3b39c8d__"